import { useEffect, useState } from 'react';

import markerSDK, { MarkerSdk } from '@marker.io/browser';

import { version } from '../../../package.json';

export const useMarkerio = () => {
  const [widget, setWidget] = useState<MarkerSdk | null>(null);

  useEffect(() => {
    markerSDK
      .loadWidget({
        customData: {
          projectVersion: version
        },
        project: import.meta.env.VITE_MARKER_IO_PROJECT_ID
      })
      .then((markerWidget) => setWidget(markerWidget));
  }, []);

  return widget;
};
